import { settings } from './../settings';
import { tools } from './../helpers/tools';
import { opus } from './../api/opus';
import { configuration } from '../api/configuration';

class Homepage {
    constructor(underscore, geo) {
        this._ = underscore;
        this.geo = geo;
        this.region = null;
        this.config = null;
        this.timeSlots = null;
        this.filteredTimeSlots = [];
        this.treatments = null;
        this.urlPath= null;
        this.sistaMinuteSetting = null;
        this.cities = [];
    }

    init(newSettings) {
        const self = this;

        settings.init(newSettings);
        //self.geo.init(google, null);
        opus.init();
        this.urlPath = window.location.pathname.split('/').length > 1 ? window.location.pathname.split('/')[1] : 'new-invisible-braces';
        configuration
            .get()
            .then(config => {
                self.config = config.result;
                let sistaMinuteSetting = tools.findByValue(self.config.lastMinute.sistaMinuteSettings, 'pathUrl', self.urlPath);
                if(!sistaMinuteSetting) {
                    sistaMinuteSetting = tools.findByValue(self.config.lastMinute.sistaMinuteSettings, 'pathUrl', 'new-invisible-braces')
                }
                self.sistaMinuteSetting = sistaMinuteSetting;
                for(var i = 0; i < self.sistaMinuteSetting.cities.length; i++) {
                    const cityObj = tools.findByValue(settings.settings.regions, 'city', self.sistaMinuteSetting.cities[i]);
                    if(cityObj) {
                        self.cities.push(cityObj);
                    }
                }
                return opus.getTreatments();
            })
            .then(() => {
                self.treatments = opus.treatments.filter(treatment => {
                    return tools.inArray(self.sistaMinuteSetting.treatments, treatment.id, 'treatmentId');
                });

                self.load();
            })
            .catch(response => {
                tools.handleError(self, response, $('#hd-lastminute-error'));
                self.showLastMinuteTimeSlot();
            });

        // $('#hd-lastminute-rows').height($('#hd-text-block-first').height() - 130);

        // $(window).off('resize');
        // $(window).on('resize', function () {
        //     debounce(
        //         () => {
        //             $('#hd-lastminute-rows').height($('#hd-text-block-first').height() - 130);
        //         },
        //         150,
        //         'hd-lastminute-rows'
        //     );
        // });
    }

    load() {
        const self = this;
        // let item = 1;

        // setInterval(function(){
        //     $(`#hd-summer-bumper-${item}`).hide();

        //     item++;
        //     if (item > 3)
        //         item = 1;

        //     $(`#hd-summer-bumper-${item}`).show();
        // }, 3000);

        $('#hd-lastminute-more')
            .off('click')
            .on('click', function (e) {
                e.preventDefault();

                window.location = $(this).attr('href') + '?city=' + self.region.city;
            });

        if (self.cities && self.cities.length > 0) {

            self.region = self.cities[0];
            $('#hd-lastminute-cities ul').html('');
            for (let i = 0; i < self.cities.length; i++) {
                $('#hd-lastminute-cities ul').append(
                    `<li${self.region.city == self.cities[i].city ? ' class="active"' : ''}><a href="#" data-id=${self.cities[i].city}>${
                    self.cities[i].city
                    }</a></li>`
                );
            }

            $('#hd-lastminute-cities li a')
                .off('click')
                .on('click', function (e) {
                    e.preventDefault();

                    $('#hd-lastminute-notimeslots').hide();

                    $('#hd-lastminute-cities li').removeClass('active');

                    $(this)
                        .parent()
                        .addClass('active');

                    self.region = tools.findByValue(settings.settings.regions, 'city', $(this).attr("data-id"));
                    self.getTimeSlots();
                });

            self.getTimeSlots();
            // });
        } else {
            self.region = settings.settings.regions[0];
        }
    }

    getTimeSlots() {
        const self = this;
        const now = new Date();
        const dates = [now];
        const filteredClinics = [];
        const container = $('#hd-lastminute-rows');

        let maxDate = tools.addHoursToDate(self.config.lastMinute.includeTimeSlotsWithin, now);
        let days = Math.ceil(self.config.lastMinute.includeTimeSlotsWithin / 24) + 1;

        for (let i = 1; i < days; i++) {
            const date = tools.addDaysToDate(i, now);

            if (!(date.getDay() % 6)) {
                // Weekend, add a day and skip in result
                maxDate = tools.addDaysToDate(1, maxDate);
                days++;
            } else {
                dates.push(date);
            }
        }

        container.html('<div class="spinner-border" role="status"></div>').show();

        opus.getClinics()
            .then(() => {
                for (let i = 0; i < self.region.clinics.length; i++) {
                    if (tools.inArray(self.sistaMinuteSetting.clinicIds, self.region.clinics[i].id))
                        filteredClinics.push(self.region.clinics[i]);
                }

                if (self.timeSlots && self.timeSlots.length > 0) {
                    self.showTimeSlots(container, filteredClinics);

                    if (self.filteredTimeSlots.length == 0) {
                        $('#hd-lastminute-notimeslots').show();

                        $('#hd-lastminute-rows, #hd-lastminute-more').hide();
                        self.showLastMinuteTimeSlot();
                    }

                    return Promise.resolve();
                } else {
                    return opus
                        .getTimeSlotsForDays(dates, self.treatments, maxDate, null, response => {
                            self.showTimeSlots(container, filteredClinics, response);
                        })
                        .then(() => {
                            if (self.filteredTimeSlots.length == 0) {
                                $('#hd-lastminute-notimeslots').show();

                                $('#hd-lastminute-rows, #hd-lastminute-more').hide();
                                self.showLastMinuteTimeSlot();
                            }
                        });
                }
            })
            .then(() => { })
            .catch(response => {
                tools.handleError(self, response, $('#hd-lastminute-error'));

                $('#hd-lastminute-rows, #hd-lastminute-more').hide();
                self.showLastMinuteTimeSlot();
            });
    }

    showTimeSlots(container, filteredClinics, response) {
        const self = this;
        const template = self._.template($('#tmpl-hd-lastminute').html());

        self.timeSlots = response ? response.result : self.timeSlots;

        self.filteredTimeSlots = self.timeSlots
            .filter(timeSlot => {
                return tools.inArray(filteredClinics, timeSlot.clinicId, 'id');
            })
            .slice(0, settings.settings.maxNoOfLastMinuteItems);

        if (self.filteredTimeSlots.length == 0) {
            $('#hd-lastminute-rows, #hd-lastminute-more').hide();
        } else {
            $('#hd-lastminute-notimeslots').hide();

            $('#hd-lastminute-rows, #hd-lastminute-more').show();
            self.showLastMinuteTimeSlot();
        }

        container.html('');
        self.filteredTimeSlots.forEach(timeSlot => {
            if (!timeSlot.clinic) {
                timeSlot.clinic = tools.findByValue(opus.clinics, 'id', timeSlot.clinicId);
                timeSlot.clinic.name = timeSlot.clinic.name.replace('Happident ', '');
            }

            if (!timeSlot.treatment) {
                timeSlot.treatment = tools.findByValue(opus.treatments, 'id', timeSlot.treatmentId);
            }

            container.append(template(timeSlot));
        });
        $('.hd-selecttimeslot').off('click');
        $('.hd-selecttimeslot').on('click', function (e) {
            e.preventDefault();

            self.selectTimeSlot($(this).data('id'), $(this).data('clinicid'), $(this).data('start'));
        });
    }

    selectTimeSlot(id, clinicId, start) {
        const self = this;

        let timeSlot = opus.findTimeSlot(self.timeSlots, id, clinicId, start);

        if (timeSlot) {
            window.location = encodeURI(
                `/boka-tid/#${timeSlot.clinicId},${timeSlot.id},${timeSlot.start},${timeSlot.end},${timeSlot.clinicianId},${timeSlot.treatmentId},${timeSlot.discountedPrice},/`
            );
        }
    }

    showLastMinuteTimeSlot() {
        // $('#home-page-last-minute-deal-banner').fadeOut(2000, () => {
            // $('#home-page-last-minute-deal-banner').hide();
            $('#home-page-last-minute-deal').show();
        // });
    }
}

(function (hd, _) {
    hd.views = hd.views || {};
    hd.views.homepage = new Homepage(_, hd.views.geo);
    // eslint-disable-next-line no-undef
})((window.hd = window.hd || {}), _);



// WEBPACK FOOTER //
// ./scripts/booking/views/homepage.js